import React, { useEffect, useState } from "react";
import {
  Button,
  Chip,
  DocumentsList,
  FormFieldSet,
  Modal,
  useFormHandler,
} from "../../../../../../components";
import { CommissionType } from "../../../../../../assets/data/enumData";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import { addNewPlacementStart } from "../../../../../../redux/slices/placements/placementsSlice";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { ENDPOINTS } from "../../../../../../redux/apiConfig";
import axiosRequest from "../../../../../../redux/slices/universal/axiosService";
const Payments = ({ setActiveTab, currentPlacement, editData, incomingData }) => {
  console.log({ editData });
  const isEditable = !!editData;
  const dispatch = useDispatch();
  const { employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );
  const [fetchPerticularData, setFetchPerticularData] = useState(null);
  const [attachmentModal, setAttachmentModal] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [clientRequirement, setClientRequirement] = useState({});
  const existingPayments = editData?.payments || [];
  const latestPayment = existingPayments.length > 0 ? existingPayments[existingPayments.length - 1] : null;

  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      annualSalary: latestPayment?.annualPay || (incomingData?.offeredSalary ? String(incomingData.offeredSalary) : ""),
      commissionType: latestPayment?.commission?.type || (incomingData?.commissionType ? Number(incomingData.commissionType) : 1), // Default to Flat (1) if no data
      commissionValue: latestPayment?.commission?.value || (incomingData?.targetAmount ? String(incomingData.targetAmount) : ""),
      poNumber: latestPayment?.poNum || "",
      purchaseOrder: [],
      comments: "",
      agreements: "No",
      agreementsFile: [],
      offerLetters: "No",
      offerLettersFile: [],
    },
    {
      annualSalary: { type: "text", required: true, number: true },
      commissionType: { type: "select", required: true },
      commissionValue: { type: "text", required: true, number: true },
      purchaseOrder: {
        type: "file",
        required: true,
        // allowedFiles: [
        //   // { ext: "png", mime: "image/png" },
        //   { ext: "txt", mime: "text/plain" },
        // ],
      },
      agreementsFile: { type: "file" },
      offerLettersFile: { type: "file" },
    },
  );

  const handleSave = () => {
    const valid = validateAllFields();
    if (valid) {
      const annualSalaryVal = Number(formData?.annualSalary || 0);
      let finalCommValue = Number(formData?.commissionValue || 0);

      const userFormData = {
        incomingPlacementId: incomingData?.incomingPlacementId,
        annualPay: formData?.annualSalary,
        commission: {
          type: formData?.commissionType, 
          value: finalCommValue, 
        },
        poNum: formData?.poNumber,
        comments: formData?.comments,
        hasAgreement: {
          type: formData?.agreements !== "No",
        },
        hasOffer: {
          type: formData?.offerLetters !== "No",
        },
      };
      const payments = fetchPerticularData?.payments;
      const paymentspatchId =
        Array.isArray(payments) && payments.length > 0
          ? payments[payments.length - 1]?._id
          : undefined;
      const uiid = fetchPerticularData?.uiid ?? "";
      if (paymentspatchId) {
        userFormData.updated = {
          on: new Date(),
          by: employeeProfileUiid,
        };
      } else {
        userFormData.added = {
          on: new Date(),
          by: employeeProfileUiid,
        };
      }
      const submissionData = filterEmptyValues(userFormData);
      const cleanAttachments =
        Array.isArray(formData.purchaseOrder) &&
        formData.purchaseOrder.length > 0
          ? formData.purchaseOrder.map((file) => {
              file.id = uuidv4(); // ✅ Add id directly
              return file;
            })
          : [];
      const cleanAttachmentsagreementsFile =
        Array.isArray(formData.agreementsFile) &&
        formData.agreementsFile.length > 0
          ? formData.agreementsFile.map((file) => {
              file.id = uuidv4(); // ✅ Add id directly
              return file;
            })
          : [];
      const cleanAttachmentsofferLettersFile =
        Array.isArray(formData.offerLettersFile) &&
        formData.offerLettersFile.length > 0
          ? formData.offerLettersFile.map((file) => {
              file.id = uuidv4(); // ✅ Add id directly
              return file;
            })
          : [];
      if (cleanAttachments.length) {
        dispatch(
          uploadStart({
            uploadType: "multiple",
            field: "doc",
            uiid: employeeProfileUiid,
            entity: "placements",
            category: "payments",
            coll: "Placement",

            doc: [
              ...cleanAttachments,
              ...cleanAttachmentsofferLettersFile,
              ...cleanAttachmentsagreementsFile,
            ],
            onSuccess: (fileData) => {
              // Step 3: Store document references
              dispatch(
                addNewPlacementStart({
                  rsd: {
                    ...submissionData,
                    poLink: cleanAttachments.flatMap((obj) =>
                      fileData
                        .filter(
                          (file) => file?.fileRefId === obj.id && file.key,
                        )
                        .map((file) => file.key),
                    ),
                  },
                  rsn: "permanetPlacementPayments",
                  uiid: uiid,
                  ...(paymentspatchId && { patchId: paymentspatchId }),
                  payload: [
                    {
                      type: paymentspatchId ? "SET" : "PUSH",
                      value: {
                        [paymentspatchId ? "payments.$[elem]" : "payments"]: {
                          ...submissionData,
                          // poLink: fileData.map((file) => file.key),
                          poLink: cleanAttachments.flatMap((obj) =>
                            fileData
                              .filter(
                                (file) =>
                                  file?.fileRefId === obj.id && file.key,
                              )
                              .map((file) => file.key),
                          ),

                          hasAgreement: {
                            type: formData?.agreements !== "No",
                            documents: cleanAttachmentsagreementsFile.flatMap(
                              (obj) =>
                                fileData
                                  .filter(
                                    (file) =>
                                      file?.fileRefId === obj.id && file.key,
                                  )
                                  .map((file) => file.key),
                            ),
                          },

                          hasOffer: {
                            type: formData?.offerLetters !== "No",
                            documents: cleanAttachmentsofferLettersFile.flatMap(
                              (obj) =>
                                fileData
                                  .filter(
                                    (file) =>
                                      file?.fileRefId === obj.id && file.key,
                                  )
                                  .map((file) => file.key),
                            ),
                          },
                        },
                      },
                    },
                  ],
                  onSuccess: async (payload) => {
                    setActiveTab((prev) => prev + 1);
                    // setTimeout(() => {
                    //   setActiveTab((prev) => prev + 1);
                    // }, 500);
                  },
                }),
              );
            },
          }),
        );
      } else {
        setActiveTab((prev) => prev + 1);
      }
    } else {
    }
  };
  // useEffect(()=>{
  //  const permanetPlacementPayments=currentPlacement?.permanetPlacementPayments
  //  console.log('permanetPlacementPayments',permanetPlacementPayments)
  //  if(permanetPlacementPayments){
  //   handleChange("annualSalary", permanetPlacementPayments?.annualPay)
  //   handleChange("commissionType", permanetPlacementPayments?.commission?.type)
  //   handleChange("commissionValue", permanetPlacementPayments?.commission?.value)
  //   handleChange("poNumber", permanetPlacementPayments?.poNum)
  //   handleChange("comments", permanetPlacementPayments?.comments)
  //   handleChange("agreements", permanetPlacementPayments?.hasAgreement?.type===true?"Yes":"No")
  //   handleChange("offerLetters", permanetPlacementPayments?.hasOffer?.type===true?"Yes":"No")
  //  }
  // },[currentPlacement])
  //  useEffect(()=>{
  //     const permanetPlacementPayments=currentPlacement?.permanetPlacementPayments||{}
  //    const isEmptyOrMissing =
  //     !permanetPlacementPayments ||
  //     Object.keys(permanetPlacementPayments).length === 0;
  // const payments=editData?.payments||[];
  // const paymetsLast=payments[payments.length-1]
  //   if (isEmptyOrMissing && isEditable) {
  //    handleChange("annualSalary", paymetsLast?.annualPay?`${paymetsLast?.annualPay}`:"")
  //    handleChange("commissionType", paymetsLast?.commission?.type)
  //    handleChange("commissionValue", paymetsLast?.commission?.value?`${paymetsLast?.commission?.value}`:"")
  //    handleChange("poNumber", paymetsLast?.poNum)
  //    handleChange("comments", paymetsLast?.comments)
  //    handleChange("hasAgreement", paymetsLast?.hasAgreement?.type===false?"No":paymetsLast?.hasAgreement?.type===true?"Yes":"")
  //    handleChange("offerLetters", paymetsLast?.hasOffer?.type===false?"No":paymetsLast?.hasOffer?.type===true?"Yes":"")
  //   }
  //   },[isEditable])




  function findBillClient(obj) {
    const stack = [obj];

    while (stack.length) {
      const current = stack.pop();

      if (current && typeof current === "object") {
        if (Object.prototype.hasOwnProperty.call(current, "billClient")) {
          return current.billClient;
        }

        for (const key in current) {
          stack.push(current[key]);
        }
      }
    }

    return undefined;
  }

  useEffect(() => {
    const fetchEntityDetails = async () => {
      if (!currentPlacement) return;
      const permanentPlacementJobDetails =
        currentPlacement.permanetPlacementJobDetails;
      const { billClient } = permanentPlacementJobDetails || {};
      const billClientSearched =
        findBillClient(currentPlacement) || editData?.jobInfo?.billClient?.uiid;
      console.log("billClientSearched", billClientSearched);
      const url = ENDPOINTS.CLIENTS.GET_BY_UIID;
      if (!url) return;
      try {
        const response = await axiosRequest({
          method: "GET",
          url,
          params: {
            coll: "Client",
            fil: JSON.stringify({
              uiid: {
                type: "NONE",
                value: billClientSearched ? billClientSearched : billClient,
              },
            }),
            cache: false,
            ret: "generalInfo placementDetails.permanent",
          },
        });
        if (response?.success) {
          console.log("ap trigeereed with res success", response);
          const permanent =
            response?.data?.data?.generalInfo?.placementDetails?.permanent ||
            {};
          const { commission, commissionType: clientCommType } = permanent;
          setClientRequirement(permanent || {});
          
          // Do not override if incomingData already filled values
          if (!incomingData) {
            if (clientCommType) {
              handleChange("commissionType", clientCommType);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching entity details:", error);
      }
    };

    fetchEntityDetails();
  }, [currentPlacement]);

  useEffect(() => {
    const fetchData = async () => {
      const uiid =
        currentPlacement?.uiid ??
        editData?.uiid ??
        currentPlacement?.data?.doc?.uiid ??
        "";

      if (!uiid) return;
      const filter = {
        uiid: { type: "NONE", value: uiid },
      };

      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
          params: {
            coll: "Placement",
            fil: JSON.stringify(filter),
            ret: "payments uiid poLink hasOffer hasAgreement",
          },
        });

        const data = response?.data?.data;
        if (data) {
          setFetchPerticularData(data);
          const payments = data?.payments || [];
          const lastPayment = payments[payments.length - 1];
          if (lastPayment && !incomingData) {

  handleChange("annualSalary", `${lastPayment.annualPay || ""}`);
  handleChange("commissionType", lastPayment?.commission?.type || "");
  handleChange("commissionValue", `${lastPayment?.commission?.value || ""}`);

  handleChange("poNumber", lastPayment?.poNum || "");
  handleChange("comments", lastPayment?.comments || "");

  handleChange(
    "agreements",
    lastPayment?.hasAgreement?.type === true
      ? "Yes"
      : lastPayment?.hasAgreement?.type === false
      ? "No"
      : ""
  );

  handleChange(
    "offerLetters",
    lastPayment?.hasOffer?.type === true
      ? "Yes"
      : lastPayment?.hasOffer?.type === false
      ? "No"
      : ""
  );
}
        } else {
          setFetchPerticularData(null);
        }
      } catch (error) {
        setFetchPerticularData(null);
        console.error("Failed to fetch placement data:", error);
      }
    };

    fetchData();
  }, [currentPlacement, isEditable]);
  const lastPayment =
    fetchPerticularData?.payments?.[fetchPerticularData.payments.length - 1];
  const combineAttachmentsPoLink =
    lastPayment?.poLink?.map((filePath) => ({
      filePath,
      name: "Purchase Order",
    })) || [];
  const combineAttachmentsOfferdocuments =
    lastPayment?.hasOffer?.documents?.map((filePath) => ({
      filePath,
      name: "Offer Letter",
    })) || [];
  const combineAttachmentsAgreementsdocuments =
    lastPayment?.hasAgreement?.documents?.map((filePath) => ({
      filePath,
      name: "Agreements",
    })) || [];

  return (
    // <div className="px-8 py-4 border-[1px] border-neutrals-50 rounded-b min-h-[69vh] overflow-auto">
    <div className="px-8 py-4 border-[1px] border-neutrals-50 rounded-b overflow-auto">
      <div className="grid grid-cols-2 lg:grid-cols-3 max-w-7xl gap-x-8 gap-y-6">
        <div>
          <FormFieldSet
            type="text"
            title={"Annual Salary of Consultant"}
            placeholder="Enter Annual Salary Of Consultant"
            value={formData.annualSalary}
            onChange={(value) => handleChange("annualSalary", value)}
            error={errors.annualSalary}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title={"Commission Type"}
            placeholder="Select Commission Type"
            value={formData.commissionType}
            onChange={(value) => handleChange("commissionType", value)}
            error={errors.commissionType}
            options={CommissionType}
            // disabled={true}
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title={"Commission Value"}
            placeholder="Enter Commission Value"
            value={formData.commissionValue}
            onChange={(value) => handleChange("commissionValue", value)}
            error={errors.commissionValue}
            // disabled={true}
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title={"PO Number"}
            placeholder="Enter PO Number"
            value={formData.poNumber}
            onChange={(value) => handleChange("poNumber", value)}
            error={errors.poNumber}
          />
        </div>
        <div>
          <FormFieldSet
            type="file"
            title={"Purchase Order"}
            placeholder="Choose Files"
            value={formData.purchaseOrder}
            multiple
            onChange={(value) => handleChange("purchaseOrder", value)}
            error={errors.purchaseOrder}
          />
        </div>
        <div>
          <FormFieldSet
            type="textArea"
            title={"Comments"}
            placeholder="Enter Comments"
            value={formData.comments}
            onChange={(value) => handleChange("comments", value)}
            error={errors.comments}
          />
        </div>
        <div>
          <FormFieldSet
            type="radio"
            title={"Agreements"}
            options={[
              {
                label: "Yes",
                value: "Yes",
              },
              { label: "No", value: "No" },
            ]}
            value={formData.agreements}
            onChange={(event) => handleChange("agreements", event.target.value)}
            name="Agreements"
          />
        </div>
        {formData.agreements === "Yes" && (
          <div>
            <FormFieldSet
              type="file"
              title={"Agreements Upload File"}
              placeholder="Choose File"
              value={formData.agreementsFile}
              onChange={(value) => handleChange("agreementsFile", value)}
              error={errors.agreementsFile}
            />
          </div>
        )}

        <div>
          <FormFieldSet
            type="radio"
            title={"Offer Letters"}
            options={[
              {
                label: "Yes",
                value: "Yes",
              },
              { label: "No", value: "No" },
            ]}
            value={formData.offerLetters}
            onChange={(event) =>
              handleChange("offerLetters", event.target.value)
            }
            name="Offer Letters"
          />
        </div>
        {formData.offerLetters === "Yes" && (
          <div>
            <FormFieldSet
              type="file"
              title={"Offer Letters Upload File"}
              placeholder="Choose File"
              value={formData.offerLettersFile}
              onChange={(value) => handleChange("offerLettersFile", value)}
              error={errors.offerLettersFile}
            />
          </div>
        )}
      </div>
      {fetchPerticularData && (
        <div className="max-w-7xl grid-cols-3 grid gap-x-8 gap-y-6 xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          <div
            className=" flex rounded-md items-center cursour-pointer"
            onClick={() => {
              setAttachmentModal(!attachmentModal);
              setSelectedDocuments(combineAttachmentsPoLink);
            }}
          >
            <Chip
              label={`Purchase Order:-${combineAttachmentsPoLink.length}`}
              icon={"docs"}
              iconPosition={"before"}
            />
          </div>
          <div
            className=" flex rounded-md items-center cursour-pointer"
            onClick={() => {
              setAttachmentModal(!attachmentModal);
              setSelectedDocuments(combineAttachmentsOfferdocuments);
            }}
          >
            <Chip
              label={`Offer Letter:-${combineAttachmentsOfferdocuments.length}`}
              icon={"docs"}
              iconPosition={"before"}
            />
          </div>
          <div
            className=" flex rounded-md items-center cursour-pointer"
            onClick={() => {
              setAttachmentModal(!attachmentModal);
              setSelectedDocuments(combineAttachmentsAgreementsdocuments);
            }}
          >
            <Chip
              label={`Agreements:-${combineAttachmentsAgreementsdocuments.length}`}
              icon={"docs"}
              iconPosition={"before"}
            />
          </div>
        </div>
      )}
      <div className="flex gap-3 justify-end mt-6">
        <Button title={"Cancel"} variant="outlined" />
        <Button title={"Save"} onClick={() => handleSave()} />
      </div>
      <Modal
        isOpen={attachmentModal}
        onClose={() => setAttachmentModal(false)}
        // title="Attachment View"
        // width="max-w-5xl"
        width="max-w-2xl"
        title={"Document Details"}
      >
        {/* <div className="flex flex-col justify-center items-center gap-8">
              <h6>attachement Details</h6> */}
        <DocumentsList data={selectedDocuments} />
        {/* <Button
                title={"Close"}
                onClick={() => setAttachmentModal(false)}
              /> */}
        {/* </div> */}
      </Modal>
    </div>
  );
};

export default Payments;
